import registrationErrorMessagesTemplate from "./registrationErrorMessagesTemplate";
import registrationUniqueIdentifierMessagesTemplate from "./messages/registrationUniqueIdentifierMessagesTemplate";
import registrationPlanIDMessagesTemplate from "./messages/registrationPlanIDMessagesTemplate";
import registrationFormTemplate from "./registrationFormTemplate";
import registrationFormSubmitTemplate from "./registrationFormSubmitTemplate";
import registrationWithoutPINUniqueIDTooltipTemplate from "./messages/registrationWithoutPINUniqueIDTooltipTemplate";

const registrationAndResetTemplate = `
<div class="form-group has-error" ng-if="autherizationMessage" id="screenReaderAuth" tabindex="0">
    <span class="help-block">{{autherizationMessage | translate:autherizationMessageParams}}</span>
</div>

<!-- Screen Reader Error Block -->
<div ng-if="registerForm.$submitted && registerForm.$invalid">
    ${registrationErrorMessagesTemplate}
</div>

<div class="panel-group" ng-if="!accuCustomization.showLoginSetupRecoveryRadio">
    ${registrationFormTemplate}
    ${registrationFormSubmitTemplate}
</div>

<div ng-if="accuCustomization.showLoginSetupRecoveryRadio" class="panel-group" id="accordion" role="tablist" aria-multiselectable="true">
    <div class="panel panel-default">
        <div class="panel-heading" id="ssnHeading">
            <label class="panel-title">
                <input role="tab" data-parent="#accordion" href="#collapseSSN" aria-controls="collapseSSN"
                    type="radio" ng-click="onClickIdentifierType($event)" ng-change="identifierTypeChange()" id="hasSSN"
                    name="identifierType" ng-model="individual.identifierType" value="ssn" />
                    {{"registerWithSSN" | translate}}
            </label>
        </div>
    </div>

    <div id="collapseSSN" ng-if="individual.identifierType === 'ssn'" class="panel-collapse collapse in" role="tabpanel" aria-labelledby="ssnHeading">
        ${registrationFormTemplate}
    </div>
    <div class="panel panel-default">
        <div class="panel-heading" id="uniqueIDHeading">
            <label class="panel-title">
                <input role="tab" data-parent="#accordion" href="#collapseUniqueID" aria-controls="collapseUniqueID"
                    type="radio" ng-click="onClickIdentifierType($event)" id="hasUniqueID" name="uniqueIdentifierType"
                    ng-model="individual.identifierType" ng-change="identifierTypeChange()" value="uniqueid" />
                    {{"registerWithUniqueID" | translate}}
                <button class="btn btn-link btn-no-style registration-reset-tooltip" type="button"
                    ng-blur="uniqueIdentifierTooltipSelect()" ng-click="uniqueIdentifierTooltipSelect()" aria-label="{{"uniqueIDTooltip.moreInfo" | translate}}"
                    tooltip-placement="top" tooltip-trigger="focus" ng-keydown="uniqueIdentifierTooltipEscape($event)"
                    uib-tooltip-html="'${registrationWithoutPINUniqueIDTooltipTemplate}'">
                    <i style="color: white; font-weight: bold;" class="em-info-icon"></i>
                </button>
            </label>
        </div>
    </div>
    <div id="collapseUniqueID" ng-if="individual.identifierType === 'uniqueid'" class="panel-collapse collapse" role="tabpanel" aria-labelledby="uniqueIDHeading">
        <div class="panel-body">
            <fieldset aria-labelledby="hasUniqueID">
                <div class="form-group" ng-class="getFormGroupClass('uniqueIdentifier');">

                    <label for="uniqueIdentifierInput" class="control-label">{{"individual.uniqueID" | translate}}</label>
                    <input type="text" name="uniqueIdentifier" autocomplete="off" id="uniqueIdentifierInput"
                        class="form-control col-5" inputmode="numeric" ng-model="individual.uniqueIdentifier"
                        ng-change="uniqueIdentifierChange($event)" data-ng-required="areFieldsRequired.uniqueidFields"
                        maxlength="10" reg-ex-input reg-ex="^[0-9]+$" ng-focus="setInputFocus($event)"
                        title="Unique identifier must be numeric" ng-blur="removeInputFocus($event);uniqueIdentifierChange($event)" />
                    ${registrationUniqueIdentifierMessagesTemplate}
                    <span class="help-block">{{uniqueIdentifierError}}</span>
                </div>
                <div class="form-group" ng-class="getFormGroupClass('planID');">

                    <label for="planIDInput" class="control-label">{{"individual.planID" | translate}}</label>
                    <input type="text" name="planID" autocomplete="off" id="planIDInput" class="form-control col-5"
                        inputmode="numeric" ng-model="individual.planID" data-ng-required="areFieldsRequired.uniqueidFields"
                        maxlength="12" reg-ex-input reg-ex="^[0-9]+$" ng-focus="setInputFocus($event)"
                        ng-change="planIDChange($event)" title="Plan ID must be numeric" ng-blur="removeInputFocus($event);planIDChange($event)" />
                    ${registrationPlanIDMessagesTemplate}
                    <span class="help-block">{{planIDError}}</span>
                </div>
                <div class="form-group" ng-class="getFormGroupClass('uniqueidLastName');">
                    <label for="uniqueidLastNameInput" class="control-label">{{"individual.lastName" | translate}}</label>

                    <input type="text" class="form-control" id="uniqueidLastNameInput" name="uniqueidLastName" autocomplete="off"
                        ng-required="areFieldsRequired.uniqueidFields" ng-model="individual.uniqueidLastName" maxlength="35" ng-focus="setInputFocus($event)"
                        ng-change="lastNameChange($event)" title="Lastname"
                        ng-blur="removeInputFocus($event);lastNameChange($event);" />

                        <ng-messages 
                            for="getFieldError('uniqueidLastName');"
                            ng-show="displayFieldMessages('uniqueidLastName',focusMgr['uniqueidLastName']);"
                            multiple
                            data-ng-class="getValidationErrorClass('uniqueidLastName');"
                        >
                            <ng-message when="required">
                                {{"lastNameRequired"  | translate}}
                            </ng-message>
                        </ng-messages>
                    <span class="help-block">{{uniqueidLastNameError}}</span>
                </div>

                <div class="form-group" ng-class="getFormGroupClass('uniqueidDateOfBirth');">
                    <label for="uniqueidDateOfBirth" class="control-label">{{"individual.dateOfBirth" | translate}}&nbsp;
                        <span class="label-format" aria-hidden="true">MM/DD/YYYY</span>
                    </label>
                    <pw-beneficiary-date date-id="uniqueidDateOfBirth" date-name="uniqueidDateOfBirth"
                        date-title="Format two digit month, two digit day and four digit year"
                        date-model="individual.uniqueidDateOfBirth" is-required="areFieldsRequired.uniqueidFields" is-disabled="false"
                        date-focus="touchDateOfBirth($event);toggleDateOfBirthFromClick($event);setInputFocus($event)"
                        date-blur="handleMaskDateOfBirth($event);removeInputFocus($event);dobChange($event)" dob-change="dobChange($event)"
                        min-date="getMinimumDateOfBirth()" ui-options="{clearOnBlur:false, allowInvalidValue: true}"
                        allow-future-date="true" mask-date="true"
                        ng-keydown="toggleDOBfromKeyDown($event)"></pw-beneficiary-date>

                        <ng-messages 
                            for="getFieldError('uniqueidDateOfBirth');" 
                            ng-show="displayFieldMessages('uniqueidDateOfBirth',focusMgr['uniqueidDateOfBirth']);"
                            multiple 
                            data-ng-class="getValidationErrorClass('uniqueidDateOfBirth');"
                        >
                            <ng-message when="required">
                                {{ 'dateOfBirthRequired' | translate }}
                            </ng-message>
                            <ng-message when="valid || pattern">
                                {{ 'dateOfBirthInvalid' | translate }}
                            </ng-message>
                            <ng-message when="minYear">
                                {{ 'dateOfBirthYearOutOfRange' | translate }}
                            </ng-message>
                            <ng-message when="futureDateNotAllowed">
                                {{ 'dateOfBirthFutureDateNotAllowed' | translate }}
                            </ng-message>
                        </ng-messages>
                    <span class="help-block">{{uniqueidDateOfBirthError}}</span>
                </div>
            </fieldset>
        </div>
    </div>
    ${registrationFormSubmitTemplate}
</div>
`;
export default registrationAndResetTemplate;
